import {
  Companion_getInstance1cdih9ztewhpv as Companion_getInstance,
  Projecto73xqbcrzskm as Project,
  ShortId1uz90q3uk7eoq as ShortId,
  Companion_instance3eje2t5q7hpt as Companion_instance,
  LockInfo3qyh26jodrlpf as LockInfo,
} from './databaseModels.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import {
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
  properties1qnxlk10mmfrs as properties,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  Addresscpovxna1tjmg as Address,
  _MonetaryValue___init__impl__jsc11x21b8u6q6nd7yd as _MonetaryValue___init__impl__jsc11x,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  ClientFeedback208nr9qsd3d5f as ClientFeedback,
  AccessInfoj60d6hx1qs8r as AccessInfo,
  CompletionRequest2ew7c02dda2ep as CompletionRequest,
} from './supportModels.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtSetjrjc7fhfd6b9 as KtSet,
} from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  ProjectState_Creating_getInstancegu71uom71mst as ProjectState_Creating_getInstance,
  ProjectState18nmtnu5v70wt as ProjectState,
} from './enums.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance_0 } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_customer(_this__u8e3s4) {
  return _this__u8e3s4.prop(Project_customer_getInstance());
}
function get_contractor(_this__u8e3s4) {
  return _this__u8e3s4.prop(Project_contractor_getInstance());
}
function get_state(_this__u8e3s4) {
  return _this__u8e3s4.prop(Project_state_getInstance());
}
function get_created(_this__u8e3s4) {
  return _this__u8e3s4.prop(Project_created_getInstance());
}
function get_contractorShortId(_this__u8e3s4) {
  return _this__u8e3s4.prop(Project_contractorShortId_getInstance());
}
function get_shortId(_this__u8e3s4) {
  return _this__u8e3s4.prop(Project_shortId_getInstance());
}
function get_name(_this__u8e3s4) {
  return _this__u8e3s4.prop(Project_name_getInstance());
}
function get_isArchived(_this__u8e3s4) {
  return _this__u8e3s4.prop(Project_isArchived_getInstance());
}
function get_client(_this__u8e3s4) {
  return _this__u8e3s4.prop(Project_client_getInstance());
}
function get_clientDeposits(_this__u8e3s4) {
  return _this__u8e3s4.prop(Project_clientDeposits_getInstance());
}
function get_contractorPayments(_this__u8e3s4) {
  return _this__u8e3s4.prop(Project_contractorPayments_getInstance());
}
function Project_client$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function Project_client$_get_name_$ref_wa2if2() {
  return (p0) => p0.k20();
}
function Project_client$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_client$_get_serializer_$ref_cm1me3() {
  return (p0) => p0.j2j();
}
function Project_client$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function Project_client$_get_annotations_$ref_jq4xqh() {
  return (p0) => p0.bz();
}
var Project_clientClass;
function Project_client() {
  if (Project_clientClass === VOID) {
    class $ {
      constructor() {
        Project_client_instance = this;
        var tmp = this;
        tmp.r7a_1 = lazy(Project_client$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s7a_1 = lazy(Project_client$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t7a_1 = lazy(Project_client$annotations$delegate$lambda);
        this.u7a_1 = null;
        this.v7a_1 = 'null';
      }
      k20() {
        var tmp0 = this.r7a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_client$_get_name_$ref_wa2if2(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.c7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      l7c(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.l7c(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.s7a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_client$_get_serializer_$ref_cm1me3(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t7a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_client$_get_annotations_$ref_jq4xqh(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_client', VOID, VOID, [SerializableProperty()]);
    Project_clientClass = $;
  }
  return Project_clientClass;
}
var Project_client_instance;
function Project_client_getInstance() {
  if (Project_client_instance === VOID)
    new (Project_client())();
  return Project_client_instance;
}
function Project_name$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function Project_name$_get_name_$ref_dgomim() {
  return (p0) => p0.k20();
}
function Project_name$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_name$_get_serializer_$ref_e1dxsr() {
  return (p0) => p0.j2j();
}
function Project_name$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function Project_name$_get_annotations_$ref_73dalz() {
  return (p0) => p0.bz();
}
var Project_nameClass;
function Project_name() {
  if (Project_nameClass === VOID) {
    class $ {
      constructor() {
        Project_name_instance = this;
        var tmp = this;
        tmp.n7c_1 = lazy(Project_name$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o7c_1 = lazy(Project_name$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p7c_1 = lazy(Project_name$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.n7c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_name$_get_name_$ref_dgomim(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.d7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      q7c(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.q7c(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.o7c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_name$_get_serializer_$ref_e1dxsr(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p7c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_name$_get_annotations_$ref_73dalz(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_name', VOID, VOID, [SerializableProperty()]);
    Project_nameClass = $;
  }
  return Project_nameClass;
}
var Project_name_instance;
function Project_name_getInstance() {
  if (Project_name_instance === VOID)
    new (Project_name())();
  return Project_name_instance;
}
function Project_description$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function Project_description$_get_name_$ref_ph672b() {
  return (p0) => p0.k20();
}
function Project_description$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_description$_get_serializer_$ref_wxdhhy() {
  return (p0) => p0.j2j();
}
function Project_description$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function Project_description$_get_annotations_$ref_a7c8a6() {
  return (p0) => p0.bz();
}
var Project_descriptionClass;
function Project_description() {
  if (Project_descriptionClass === VOID) {
    class $ {
      constructor() {
        Project_description_instance = this;
        var tmp = this;
        tmp.r7c_1 = lazy(Project_description$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s7c_1 = lazy(Project_description$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t7c_1 = lazy(Project_description$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.r7c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_description$_get_name_$ref_ph672b(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.e7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      q7c(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.q7c(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.s7c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_description$_get_serializer_$ref_wxdhhy(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t7c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_description$_get_annotations_$ref_a7c8a6(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_description', VOID, VOID, [SerializableProperty()]);
    Project_descriptionClass = $;
  }
  return Project_descriptionClass;
}
var Project_description_instance;
function Project_description_getInstance() {
  if (Project_description_instance === VOID)
    new (Project_description())();
  return Project_description_instance;
}
function Project_address$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(8);
}
function Project_address$_get_name_$ref_nloxtn() {
  return (p0) => p0.k20();
}
function Project_address$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_address$_get_serializer_$ref_vbejfi() {
  return (p0) => p0.j2j();
}
function Project_address$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(8);
}
function Project_address$_get_annotations_$ref_vbcy5i() {
  return (p0) => p0.bz();
}
var Project_addressClass;
function Project_address() {
  if (Project_addressClass === VOID) {
    class $ {
      constructor() {
        Project_address_instance = this;
        var tmp = this;
        tmp.u7c_1 = lazy(Project_address$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v7c_1 = lazy(Project_address$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w7c_1 = lazy(Project_address$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.u7c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_address$_get_name_$ref_nloxtn(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.f7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      x7c(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.x7c(tmp, value instanceof Address() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.v7c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_address$_get_serializer_$ref_vbejfi(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w7c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_address$_get_annotations_$ref_vbcy5i(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_address', VOID, VOID, [SerializableProperty()]);
    Project_addressClass = $;
  }
  return Project_addressClass;
}
var Project_address_instance;
function Project_address_getInstance() {
  if (Project_address_instance === VOID)
    new (Project_address())();
  return Project_address_instance;
}
function Project_location$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(9);
}
function Project_location$_get_name_$ref_vv2pi0() {
  return (p0) => p0.k20();
}
function Project_location$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_location$_get_serializer_$ref_pk1cpb() {
  return (p0) => p0.j2j();
}
function Project_location$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(9);
}
function Project_location$_get_annotations_$ref_r0mekt() {
  return (p0) => p0.bz();
}
var Project_locationClass;
function Project_location() {
  if (Project_locationClass === VOID) {
    class $ {
      constructor() {
        Project_location_instance = this;
        var tmp = this;
        tmp.y7c_1 = lazy(Project_location$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z7c_1 = lazy(Project_location$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a7d_1 = lazy(Project_location$annotations$delegate$lambda);
        this.b7d_1 = null;
        this.c7d_1 = 'null';
      }
      k20() {
        var tmp0 = this.y7c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_location$_get_name_$ref_vv2pi0(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.g7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      d7d(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.d7d(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.z7c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_location$_get_serializer_$ref_pk1cpb(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a7d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_location$_get_annotations_$ref_r0mekt(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_location', VOID, VOID, [SerializableProperty()]);
    Project_locationClass = $;
  }
  return Project_locationClass;
}
var Project_location_instance;
function Project_location_getInstance() {
  if (Project_location_instance === VOID)
    new (Project_location())();
  return Project_location_instance;
}
function Project_jobNumber$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(10);
}
function Project_jobNumber$_get_name_$ref_skcc5v() {
  return (p0) => p0.k20();
}
function Project_jobNumber$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[10];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_jobNumber$_get_serializer_$ref_98rydw() {
  return (p0) => p0.j2j();
}
function Project_jobNumber$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(10);
}
function Project_jobNumber$_get_annotations_$ref_ijbgko() {
  return (p0) => p0.bz();
}
var Project_jobNumberClass;
function Project_jobNumber() {
  if (Project_jobNumberClass === VOID) {
    class $ {
      constructor() {
        Project_jobNumber_instance = this;
        var tmp = this;
        tmp.e7d_1 = lazy(Project_jobNumber$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f7d_1 = lazy(Project_jobNumber$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g7d_1 = lazy(Project_jobNumber$annotations$delegate$lambda);
        this.h7d_1 = null;
        this.i7d_1 = 'null';
      }
      k20() {
        var tmp0 = this.e7d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_jobNumber$_get_name_$ref_skcc5v(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.h7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      d7d(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.d7d(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.f7d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_jobNumber$_get_serializer_$ref_98rydw(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g7d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_jobNumber$_get_annotations_$ref_ijbgko(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_jobNumber', VOID, VOID, [SerializableProperty()]);
    Project_jobNumberClass = $;
  }
  return Project_jobNumberClass;
}
var Project_jobNumber_instance;
function Project_jobNumber_getInstance() {
  if (Project_jobNumber_instance === VOID)
    new (Project_jobNumber())();
  return Project_jobNumber_instance;
}
function Project_files$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(11);
}
function Project_files$_get_name_$ref_3m3ihu() {
  return (p0) => p0.k20();
}
function Project_files$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[11];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_files$_get_serializer_$ref_l4eojf() {
  return (p0) => p0.j2j();
}
function Project_files$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(11);
}
function Project_files$_get_annotations_$ref_l2fkn() {
  return (p0) => p0.bz();
}
var Project_filesClass;
function Project_files() {
  if (Project_filesClass === VOID) {
    class $ {
      constructor() {
        Project_files_instance = this;
        var tmp = this;
        tmp.j7d_1 = lazy(Project_files$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.k7d_1 = lazy(Project_files$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.l7d_1 = lazy(Project_files$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'kotlin.collections.listOf' call
        tmp_2.m7d_1 = emptyList();
        this.n7d_1 = 'listOf()';
      }
      k20() {
        var tmp0 = this.j7d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_files$_get_name_$ref_3m3ihu(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.i7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      o7d(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.o7d(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.k7d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_files$_get_serializer_$ref_l4eojf(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.l7d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_files$_get_annotations_$ref_l2fkn(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_files', VOID, VOID, [SerializableProperty()]);
    Project_filesClass = $;
  }
  return Project_filesClass;
}
var Project_files_instance;
function Project_files_getInstance() {
  if (Project_files_instance === VOID)
    new (Project_files())();
  return Project_files_instance;
}
function Project_retention$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(12);
}
function Project_retention$_get_name_$ref_ij3ra3() {
  return (p0) => p0.k20();
}
function Project_retention$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[12];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_retention$_get_serializer_$ref_ros58s() {
  return (p0) => p0.j2j();
}
function Project_retention$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(12);
}
function Project_retention$_get_annotations_$ref_m2kxdc() {
  return (p0) => p0.bz();
}
var Project_retentionClass;
function Project_retention() {
  if (Project_retentionClass === VOID) {
    class $ {
      constructor() {
        Project_retention_instance = this;
        var tmp = this;
        tmp.p7d_1 = lazy(Project_retention$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q7d_1 = lazy(Project_retention$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r7d_1 = lazy(Project_retention$annotations$delegate$lambda);
        this.s7d_1 = null;
        this.t7d_1 = 'null';
      }
      k20() {
        var tmp0 = this.p7d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_retention$_get_name_$ref_ij3ra3(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.j7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      u7d(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.u7d(tmp, (value == null ? true : typeof value === 'number') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.q7d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_retention$_get_serializer_$ref_ros58s(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r7d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_retention$_get_annotations_$ref_m2kxdc(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_retention', VOID, VOID, [SerializableProperty()]);
    Project_retentionClass = $;
  }
  return Project_retentionClass;
}
var Project_retention_instance;
function Project_retention_getInstance() {
  if (Project_retention_instance === VOID)
    new (Project_retention())();
  return Project_retention_instance;
}
function get_jobNumber(_this__u8e3s4) {
  return _this__u8e3s4.prop(Project_jobNumber_getInstance());
}
function get_address(_this__u8e3s4) {
  return _this__u8e3s4.prop(Project_address_getInstance());
}
function get_location(_this__u8e3s4) {
  return _this__u8e3s4.prop(Project_location_getInstance());
}
function get_retention(_this__u8e3s4) {
  return _this__u8e3s4.prop(Project_retention_getInstance());
}
function get_description(_this__u8e3s4) {
  return _this__u8e3s4.prop(Project_description_getInstance());
}
function prepareProjectFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [Project__id_getInstance(), Project_shortId_getInstance(), Project_contractor_getInstance(), Project_contractorShortId_getInstance(), Project_customer_getInstance(), Project_client_getInstance(), Project_name_getInstance(), Project_description_getInstance(), Project_address_getInstance(), Project_location_getInstance(), Project_jobNumber_getInstance(), Project_files_getInstance(), Project_retention_getInstance(), Project_published_getInstance(), Project_readBy_getInstance(), Project_feedback_getInstance(), Project_created_getInstance(), Project_cancelled_getInstance(), Project_abandoned_getInstance(), Project_archived_getInstance(), Project_viewedByCustomer_getInstance(), Project_approved_getInstance(), Project_terminated_getInstance(), Project_complete_getInstance(), Project_isArchived_getInstance(), Project_state_getInstance(), Project_originalPrice_getInstance(), Project_activePrice_getInstance(), Project_projectCredits_getInstance(), Project_acceptedChangeAmount_getInstance(), Project_fundingRequested_getInstance(), Project_clientDeposits_getInstance(), Project_pendingClientDeposits_getInstance(), Project_contractorPayments_getInstance(), Project_clientReturn_getInstance(), Project_started_getInstance(), Project_preSubstantialCompletion_getInstance(), Project_substantialCompletion_getInstance(), Project_locked_getInstance(), Project_lastModifiedBy_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function Project_customer$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function Project_customer$_get_name_$ref_sesdhr() {
  return (p0) => p0.k20();
}
function Project_customer$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_customer$_get_serializer_$ref_7vsrfs() {
  return (p0) => p0.j2j();
}
function Project_customer$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function Project_customer$_get_annotations_$ref_f6qe58() {
  return (p0) => p0.bz();
}
var Project_customerClass;
function Project_customer() {
  if (Project_customerClass === VOID) {
    class $ {
      constructor() {
        Project_customer_instance = this;
        var tmp = this;
        tmp.v7d_1 = lazy(Project_customer$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w7d_1 = lazy(Project_customer$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x7d_1 = lazy(Project_customer$annotations$delegate$lambda);
        this.y7d_1 = null;
        this.z7d_1 = 'null';
      }
      k20() {
        var tmp0 = this.v7d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_customer$_get_name_$ref_sesdhr(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.b7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      l7c(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.l7c(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.w7d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_customer$_get_serializer_$ref_7vsrfs(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x7d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_customer$_get_annotations_$ref_f6qe58(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_customer', VOID, VOID, [SerializableProperty()]);
    Project_customerClass = $;
  }
  return Project_customerClass;
}
var Project_customer_instance;
function Project_customer_getInstance() {
  if (Project_customer_instance === VOID)
    new (Project_customer())();
  return Project_customer_instance;
}
function Project_contractor$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function Project_contractor$_get_name_$ref_kui82g() {
  return (p0) => p0.k20();
}
function Project_contractor$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_contractor$_get_serializer_$ref_kfdcmp() {
  return (p0) => p0.j2j();
}
function Project_contractor$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function Project_contractor$_get_annotations_$ref_m57or1() {
  return (p0) => p0.bz();
}
var Project_contractorClass;
function Project_contractor() {
  if (Project_contractorClass === VOID) {
    class $ {
      constructor() {
        Project_contractor_instance = this;
        var tmp = this;
        tmp.a7e_1 = lazy(Project_contractor$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b7e_1 = lazy(Project_contractor$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c7e_1 = lazy(Project_contractor$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.a7e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_contractor$_get_name_$ref_kui82g(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.z7a_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      d7e(receiver, value) {
        return receiver.m7c(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.d7e(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.b7e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_contractor$_get_serializer_$ref_kfdcmp(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c7e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_contractor$_get_annotations_$ref_m57or1(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_contractor', VOID, VOID, [SerializableProperty()]);
    Project_contractorClass = $;
  }
  return Project_contractorClass;
}
var Project_contractor_instance;
function Project_contractor_getInstance() {
  if (Project_contractor_instance === VOID)
    new (Project_contractor())();
  return Project_contractor_instance;
}
function Project_state$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(25);
}
function Project_state$_get_name_$ref_ss454o() {
  return (p0) => p0.k20();
}
function Project_state$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[25];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_state$_get_serializer_$ref_gkyrxd() {
  return (p0) => p0.j2j();
}
function Project_state$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(25);
}
function Project_state$_get_annotations_$ref_qgldv() {
  return (p0) => p0.bz();
}
var Project_stateClass;
function Project_state() {
  if (Project_stateClass === VOID) {
    class $ {
      constructor() {
        Project_state_instance = this;
        var tmp = this;
        tmp.e7e_1 = lazy(Project_state$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f7e_1 = lazy(Project_state$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g7e_1 = lazy(Project_state$annotations$delegate$lambda);
        this.h7e_1 = ProjectState_Creating_getInstance();
        this.i7e_1 = 'ProjectState.Creating';
      }
      k20() {
        var tmp0 = this.e7e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_state$_get_name_$ref_ss454o(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.w7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      j7e(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.j7e(tmp, value instanceof ProjectState() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.f7e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_state$_get_serializer_$ref_gkyrxd(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g7e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_state$_get_annotations_$ref_qgldv(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_state', VOID, VOID, [SerializableProperty()]);
    Project_stateClass = $;
  }
  return Project_stateClass;
}
var Project_state_instance;
function Project_state_getInstance() {
  if (Project_state_instance === VOID)
    new (Project_state())();
  return Project_state_instance;
}
function Project_created$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(16);
}
function Project_created$_get_name_$ref_wcy5db() {
  return (p0) => p0.k20();
}
function Project_created$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[16];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_created$_get_serializer_$ref_ynel5i() {
  return (p0) => p0.j2j();
}
function Project_created$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(16);
}
function Project_created$_get_annotations_$ref_oskgme() {
  return (p0) => p0.bz();
}
var Project_createdClass;
function Project_created() {
  if (Project_createdClass === VOID) {
    class $ {
      constructor() {
        Project_created_instance = this;
        var tmp = this;
        tmp.k7e_1 = lazy(Project_created$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l7e_1 = lazy(Project_created$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m7e_1 = lazy(Project_created$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.n7e_1 = get_default(Companion_instance_0).d1m();
        this.o7e_1 = 'now()';
      }
      k20() {
        var tmp0 = this.k7e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_created$_get_name_$ref_wcy5db(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.n7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      p7e(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.p7e(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.l7e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_created$_get_serializer_$ref_ynel5i(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m7e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_created$_get_annotations_$ref_oskgme(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_created', VOID, VOID, [SerializableProperty()]);
    Project_createdClass = $;
  }
  return Project_createdClass;
}
var Project_created_instance;
function Project_created_getInstance() {
  if (Project_created_instance === VOID)
    new (Project_created())();
  return Project_created_instance;
}
function Project_contractorShortId$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function Project_contractorShortId$_get_name_$ref_5nkd1l() {
  return (p0) => p0.k20();
}
function Project_contractorShortId$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_contractorShortId$_get_serializer_$ref_bg2bu8() {
  return (p0) => p0.j2j();
}
function Project_contractorShortId$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function Project_contractorShortId$_get_annotations_$ref_fs4znw() {
  return (p0) => p0.bz();
}
var Project_contractorShortIdClass;
function Project_contractorShortId() {
  if (Project_contractorShortIdClass === VOID) {
    class $ {
      constructor() {
        Project_contractorShortId_instance = this;
        var tmp = this;
        tmp.q7e_1 = lazy(Project_contractorShortId$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r7e_1 = lazy(Project_contractorShortId$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s7e_1 = lazy(Project_contractorShortId$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.q7e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_contractorShortId$_get_name_$ref_5nkd1l(), null);
        return tmp0.f2();
      }
      t7e(receiver) {
        return receiver.a7b_1;
      }
      m2j(receiver) {
        return new (ShortId())(this.t7e(receiver instanceof Project() ? receiver : THROW_CCE()));
      }
      u7e(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.u7e(tmp, value instanceof ShortId() ? value.n5n_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.r7e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_contractorShortId$_get_serializer_$ref_bg2bu8(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s7e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_contractorShortId$_get_annotations_$ref_fs4znw(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_contractorShortId', VOID, VOID, [SerializableProperty()]);
    Project_contractorShortIdClass = $;
  }
  return Project_contractorShortIdClass;
}
var Project_contractorShortId_instance;
function Project_contractorShortId_getInstance() {
  if (Project_contractorShortId_instance === VOID)
    new (Project_contractorShortId())();
  return Project_contractorShortId_instance;
}
function Project_shortId$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function Project_shortId$_get_name_$ref_od59k2() {
  return (p0) => p0.k20();
}
function Project_shortId$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_shortId$_get_serializer_$ref_48pjaz() {
  return (p0) => p0.j2j();
}
function Project_shortId$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function Project_shortId$_get_annotations_$ref_qnxk0n() {
  return (p0) => p0.bz();
}
var Project_shortIdClass;
function Project_shortId() {
  if (Project_shortIdClass === VOID) {
    class $ {
      constructor() {
        Project_shortId_instance = this;
        var tmp = this;
        tmp.v7e_1 = lazy(Project_shortId$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w7e_1 = lazy(Project_shortId$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x7e_1 = lazy(Project_shortId$annotations$delegate$lambda);
        this.y7e_1 = Companion_instance.k5n();
        this.z7e_1 = 'ShortId.random()';
      }
      k20() {
        var tmp0 = this.v7e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_shortId$_get_name_$ref_od59k2(), null);
        return tmp0.f2();
      }
      t7e(receiver) {
        return receiver.y7a_1;
      }
      m2j(receiver) {
        return new (ShortId())(this.t7e(receiver instanceof Project() ? receiver : THROW_CCE()));
      }
      u7e(receiver, value) {
        return receiver.m7c(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.u7e(tmp, value instanceof ShortId() ? value.n5n_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.w7e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_shortId$_get_serializer_$ref_48pjaz(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x7e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_shortId$_get_annotations_$ref_qnxk0n(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_shortId', VOID, VOID, [SerializableProperty()]);
    Project_shortIdClass = $;
  }
  return Project_shortIdClass;
}
var Project_shortId_instance;
function Project_shortId_getInstance() {
  if (Project_shortId_instance === VOID)
    new (Project_shortId())();
  return Project_shortId_instance;
}
function Project_isArchived$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(24);
}
function Project_isArchived$_get_name_$ref_l80oxr() {
  return (p0) => p0.k20();
}
function Project_isArchived$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[24];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_isArchived$_get_serializer_$ref_aleh96() {
  return (p0) => p0.j2j();
}
function Project_isArchived$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(24);
}
function Project_isArchived$_get_annotations_$ref_s7bkh6() {
  return (p0) => p0.bz();
}
var Project_isArchivedClass;
function Project_isArchived() {
  if (Project_isArchivedClass === VOID) {
    class $ {
      constructor() {
        Project_isArchived_instance = this;
        var tmp = this;
        tmp.a7f_1 = lazy(Project_isArchived$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b7f_1 = lazy(Project_isArchived$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c7f_1 = lazy(Project_isArchived$annotations$delegate$lambda);
        this.d7f_1 = false;
        this.e7f_1 = 'false';
      }
      k20() {
        var tmp0 = this.a7f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_isArchived$_get_name_$ref_l80oxr(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.v7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      f7f(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.f7f(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.b7f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_isArchived$_get_serializer_$ref_aleh96(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c7f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_isArchived$_get_annotations_$ref_s7bkh6(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_isArchived', VOID, VOID, [SerializableProperty()]);
    Project_isArchivedClass = $;
  }
  return Project_isArchivedClass;
}
var Project_isArchived_instance;
function Project_isArchived_getInstance() {
  if (Project_isArchived_instance === VOID)
    new (Project_isArchived())();
  return Project_isArchived_instance;
}
function Project_clientDeposits$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(31);
}
function Project_clientDeposits$_get_name_$ref_x837kj() {
  return (p0) => p0.k20();
}
function Project_clientDeposits$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[31];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_clientDeposits$_get_serializer_$ref_o77iey() {
  return (p0) => p0.j2j();
}
function Project_clientDeposits$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(31);
}
function Project_clientDeposits$_get_annotations_$ref_f12oce() {
  return (p0) => p0.bz();
}
var Project_clientDepositsClass;
function Project_clientDeposits() {
  if (Project_clientDepositsClass === VOID) {
    class $ {
      constructor() {
        Project_clientDeposits_instance = this;
        var tmp = this;
        tmp.g7f_1 = lazy(Project_clientDeposits$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h7f_1 = lazy(Project_clientDeposits$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i7f_1 = lazy(Project_clientDeposits$annotations$delegate$lambda);
        this.j7f_1 = _MonetaryValue___init__impl__jsc11x(0n);
        this.k7f_1 = 'MonetaryValue(0L)';
      }
      k20() {
        var tmp0 = this.g7f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_clientDeposits$_get_name_$ref_x837kj(), null);
        return tmp0.f2();
      }
      l7f(receiver) {
        return receiver.c7c_1;
      }
      m2j(receiver) {
        return new (MonetaryValue())(this.l7f(receiver instanceof Project() ? receiver : THROW_CCE()));
      }
      m7f(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.m7f(tmp, value instanceof MonetaryValue() ? value.a5s_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.h7f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_clientDeposits$_get_serializer_$ref_o77iey(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i7f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_clientDeposits$_get_annotations_$ref_f12oce(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_clientDeposits', VOID, VOID, [SerializableProperty()]);
    Project_clientDepositsClass = $;
  }
  return Project_clientDepositsClass;
}
var Project_clientDeposits_instance;
function Project_clientDeposits_getInstance() {
  if (Project_clientDeposits_instance === VOID)
    new (Project_clientDeposits())();
  return Project_clientDeposits_instance;
}
function Project_contractorPayments$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(33);
}
function Project_contractorPayments$_get_name_$ref_9yv8ut() {
  return (p0) => p0.k20();
}
function Project_contractorPayments$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[33];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_contractorPayments$_get_serializer_$ref_x1zapo() {
  return (p0) => p0.j2j();
}
function Project_contractorPayments$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(33);
}
function Project_contractorPayments$_get_annotations_$ref_onlj0g() {
  return (p0) => p0.bz();
}
var Project_contractorPaymentsClass;
function Project_contractorPayments() {
  if (Project_contractorPaymentsClass === VOID) {
    class $ {
      constructor() {
        Project_contractorPayments_instance = this;
        var tmp = this;
        tmp.n7f_1 = lazy(Project_contractorPayments$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o7f_1 = lazy(Project_contractorPayments$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p7f_1 = lazy(Project_contractorPayments$annotations$delegate$lambda);
        this.q7f_1 = _MonetaryValue___init__impl__jsc11x(0n);
        this.r7f_1 = 'MonetaryValue(0L)';
      }
      k20() {
        var tmp0 = this.n7f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_contractorPayments$_get_name_$ref_9yv8ut(), null);
        return tmp0.f2();
      }
      l7f(receiver) {
        return receiver.e7c_1;
      }
      m2j(receiver) {
        return new (MonetaryValue())(this.l7f(receiver instanceof Project() ? receiver : THROW_CCE()));
      }
      m7f(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.m7f(tmp, value instanceof MonetaryValue() ? value.a5s_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.o7f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_contractorPayments$_get_serializer_$ref_x1zapo(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p7f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_contractorPayments$_get_annotations_$ref_onlj0g(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_contractorPayments', VOID, VOID, [SerializableProperty()]);
    Project_contractorPaymentsClass = $;
  }
  return Project_contractorPaymentsClass;
}
var Project_contractorPayments_instance;
function Project_contractorPayments_getInstance() {
  if (Project_contractorPayments_instance === VOID)
    new (Project_contractorPayments())();
  return Project_contractorPayments_instance;
}
function Project__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function Project__id$_get_name_$ref_4cfuwv() {
  return (p0) => p0.k20();
}
function Project__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project__id$_get_serializer_$ref_mxdm3s() {
  return (p0) => p0.j2j();
}
function Project__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function Project__id$_get_annotations_$ref_gjak0k() {
  return (p0) => p0.bz();
}
var Project__idClass;
function Project__id() {
  if (Project__idClass === VOID) {
    class $ {
      constructor() {
        Project__id_instance = this;
        var tmp = this;
        tmp.s7f_1 = lazy(Project__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.t7f_1 = lazy(Project__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.u7f_1 = lazy(Project__id$annotations$delegate$lambda);
        this.v7f_1 = Companion_getInstance_0().m2p();
        this.w7f_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.s7f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project__id$_get_name_$ref_4cfuwv(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.x7a_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      d7e(receiver, value) {
        return receiver.m7c(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.d7e(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.t7f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project__id$_get_serializer_$ref_mxdm3s(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.u7f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project__id$_get_annotations_$ref_gjak0k(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project__id', VOID, VOID, [SerializableProperty()]);
    Project__idClass = $;
  }
  return Project__idClass;
}
var Project__id_instance;
function Project__id_getInstance() {
  if (Project__id_instance === VOID)
    new (Project__id())();
  return Project__id_instance;
}
function Project_published$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(13);
}
function Project_published$_get_name_$ref_h82bxx() {
  return (p0) => p0.k20();
}
function Project_published$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[13];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_published$_get_serializer_$ref_9dcalg() {
  return (p0) => p0.j2j();
}
function Project_published$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(13);
}
function Project_published$_get_annotations_$ref_9qk5y8() {
  return (p0) => p0.bz();
}
var Project_publishedClass;
function Project_published() {
  if (Project_publishedClass === VOID) {
    class $ {
      constructor() {
        Project_published_instance = this;
        var tmp = this;
        tmp.x7f_1 = lazy(Project_published$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y7f_1 = lazy(Project_published$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z7f_1 = lazy(Project_published$annotations$delegate$lambda);
        this.a7g_1 = null;
        this.b7g_1 = 'null';
      }
      k20() {
        var tmp0 = this.x7f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_published$_get_name_$ref_h82bxx(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.k7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      c7g(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.c7g(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.y7f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_published$_get_serializer_$ref_9dcalg(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z7f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_published$_get_annotations_$ref_9qk5y8(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_published', VOID, VOID, [SerializableProperty()]);
    Project_publishedClass = $;
  }
  return Project_publishedClass;
}
var Project_published_instance;
function Project_published_getInstance() {
  if (Project_published_instance === VOID)
    new (Project_published())();
  return Project_published_instance;
}
function Project_readBy$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(14);
}
function Project_readBy$_get_name_$ref_l2py68() {
  return (p0) => p0.k20();
}
function Project_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[14];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_readBy$_get_serializer_$ref_hfn1g9() {
  return (p0) => p0.j2j();
}
function Project_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(14);
}
function Project_readBy$_get_annotations_$ref_r5csnf() {
  return (p0) => p0.bz();
}
var Project_readByClass;
function Project_readBy() {
  if (Project_readByClass === VOID) {
    class $ {
      constructor() {
        Project_readBy_instance = this;
        var tmp = this;
        tmp.d7g_1 = lazy(Project_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.e7g_1 = lazy(Project_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.f7g_1 = lazy(Project_readBy$annotations$delegate$lambda);
        this.g7g_1 = emptySet();
        this.h7g_1 = 'emptySet()';
      }
      k20() {
        var tmp0 = this.d7g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_readBy$_get_name_$ref_l2py68(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.l7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      i7g(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.i7g(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.e7g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_readBy$_get_serializer_$ref_hfn1g9(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.f7g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_readBy$_get_annotations_$ref_r5csnf(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_readBy', VOID, VOID, [SerializableProperty()]);
    Project_readByClass = $;
  }
  return Project_readByClass;
}
var Project_readBy_instance;
function Project_readBy_getInstance() {
  if (Project_readBy_instance === VOID)
    new (Project_readBy())();
  return Project_readBy_instance;
}
function Project_feedback$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(15);
}
function Project_feedback$_get_name_$ref_h0mgug() {
  return (p0) => p0.k20();
}
function Project_feedback$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[15];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_feedback$_get_serializer_$ref_yrlw0v() {
  return (p0) => p0.j2j();
}
function Project_feedback$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(15);
}
function Project_feedback$_get_annotations_$ref_seutml() {
  return (p0) => p0.bz();
}
var Project_feedbackClass;
function Project_feedback() {
  if (Project_feedbackClass === VOID) {
    class $ {
      constructor() {
        Project_feedback_instance = this;
        var tmp = this;
        tmp.j7g_1 = lazy(Project_feedback$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.k7g_1 = lazy(Project_feedback$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.l7g_1 = lazy(Project_feedback$annotations$delegate$lambda);
        this.m7g_1 = null;
        this.n7g_1 = 'null';
      }
      k20() {
        var tmp0 = this.j7g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_feedback$_get_name_$ref_h0mgug(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.m7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      o7g(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.o7g(tmp, (value == null ? true : value instanceof ClientFeedback()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.k7g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_feedback$_get_serializer_$ref_yrlw0v(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.l7g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_feedback$_get_annotations_$ref_seutml(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_feedback', VOID, VOID, [SerializableProperty()]);
    Project_feedbackClass = $;
  }
  return Project_feedbackClass;
}
var Project_feedback_instance;
function Project_feedback_getInstance() {
  if (Project_feedback_instance === VOID)
    new (Project_feedback())();
  return Project_feedback_instance;
}
function Project_cancelled$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(17);
}
function Project_cancelled$_get_name_$ref_aa237c() {
  return (p0) => p0.k20();
}
function Project_cancelled$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[17];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_cancelled$_get_serializer_$ref_v2x541() {
  return (p0) => p0.j2j();
}
function Project_cancelled$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(17);
}
function Project_cancelled$_get_annotations_$ref_o0dm9v() {
  return (p0) => p0.bz();
}
var Project_cancelledClass;
function Project_cancelled() {
  if (Project_cancelledClass === VOID) {
    class $ {
      constructor() {
        Project_cancelled_instance = this;
        var tmp = this;
        tmp.p7g_1 = lazy(Project_cancelled$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q7g_1 = lazy(Project_cancelled$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r7g_1 = lazy(Project_cancelled$annotations$delegate$lambda);
        this.s7g_1 = null;
        this.t7g_1 = 'null';
      }
      k20() {
        var tmp0 = this.p7g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_cancelled$_get_name_$ref_aa237c(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.o7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      u7g(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.u7g(tmp, (value == null ? true : value instanceof AccessInfo()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.q7g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_cancelled$_get_serializer_$ref_v2x541(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r7g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_cancelled$_get_annotations_$ref_o0dm9v(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_cancelled', VOID, VOID, [SerializableProperty()]);
    Project_cancelledClass = $;
  }
  return Project_cancelledClass;
}
var Project_cancelled_instance;
function Project_cancelled_getInstance() {
  if (Project_cancelled_instance === VOID)
    new (Project_cancelled())();
  return Project_cancelled_instance;
}
function Project_abandoned$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(18);
}
function Project_abandoned$_get_name_$ref_55lcwr() {
  return (p0) => p0.k20();
}
function Project_abandoned$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[18];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_abandoned$_get_serializer_$ref_o0te9q() {
  return (p0) => p0.j2j();
}
function Project_abandoned$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(18);
}
function Project_abandoned$_get_annotations_$ref_iaho3q() {
  return (p0) => p0.bz();
}
var Project_abandonedClass;
function Project_abandoned() {
  if (Project_abandonedClass === VOID) {
    class $ {
      constructor() {
        Project_abandoned_instance = this;
        var tmp = this;
        tmp.v7g_1 = lazy(Project_abandoned$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w7g_1 = lazy(Project_abandoned$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x7g_1 = lazy(Project_abandoned$annotations$delegate$lambda);
        this.y7g_1 = null;
        this.z7g_1 = 'null';
      }
      k20() {
        var tmp0 = this.v7g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_abandoned$_get_name_$ref_55lcwr(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.p7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      u7g(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.u7g(tmp, (value == null ? true : value instanceof AccessInfo()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.w7g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_abandoned$_get_serializer_$ref_o0te9q(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x7g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_abandoned$_get_annotations_$ref_iaho3q(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_abandoned', VOID, VOID, [SerializableProperty()]);
    Project_abandonedClass = $;
  }
  return Project_abandonedClass;
}
var Project_abandoned_instance;
function Project_abandoned_getInstance() {
  if (Project_abandoned_instance === VOID)
    new (Project_abandoned())();
  return Project_abandoned_instance;
}
function Project_archived$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(19);
}
function Project_archived$_get_name_$ref_p3hyob() {
  return (p0) => p0.k20();
}
function Project_archived$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[19];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_archived$_get_serializer_$ref_l676vw() {
  return (p0) => p0.j2j();
}
function Project_archived$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(19);
}
function Project_archived$_get_annotations_$ref_x5vi74() {
  return (p0) => p0.bz();
}
var Project_archivedClass;
function Project_archived() {
  if (Project_archivedClass === VOID) {
    class $ {
      constructor() {
        Project_archived_instance = this;
        var tmp = this;
        tmp.a7h_1 = lazy(Project_archived$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b7h_1 = lazy(Project_archived$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c7h_1 = lazy(Project_archived$annotations$delegate$lambda);
        this.d7h_1 = null;
        this.e7h_1 = 'null';
      }
      k20() {
        var tmp0 = this.a7h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_archived$_get_name_$ref_p3hyob(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.q7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      u7g(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.u7g(tmp, (value == null ? true : value instanceof AccessInfo()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.b7h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_archived$_get_serializer_$ref_l676vw(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c7h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_archived$_get_annotations_$ref_x5vi74(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_archived', VOID, VOID, [SerializableProperty()]);
    Project_archivedClass = $;
  }
  return Project_archivedClass;
}
var Project_archived_instance;
function Project_archived_getInstance() {
  if (Project_archived_instance === VOID)
    new (Project_archived())();
  return Project_archived_instance;
}
function Project_viewedByCustomer$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(20);
}
function Project_viewedByCustomer$_get_name_$ref_ddufkk() {
  return (p0) => p0.k20();
}
function Project_viewedByCustomer$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[20];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_viewedByCustomer$_get_serializer_$ref_nwsrot() {
  return (p0) => p0.j2j();
}
function Project_viewedByCustomer$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(20);
}
function Project_viewedByCustomer$_get_annotations_$ref_ety83b() {
  return (p0) => p0.bz();
}
var Project_viewedByCustomerClass;
function Project_viewedByCustomer() {
  if (Project_viewedByCustomerClass === VOID) {
    class $ {
      constructor() {
        Project_viewedByCustomer_instance = this;
        var tmp = this;
        tmp.f7h_1 = lazy(Project_viewedByCustomer$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g7h_1 = lazy(Project_viewedByCustomer$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h7h_1 = lazy(Project_viewedByCustomer$annotations$delegate$lambda);
        this.i7h_1 = null;
        this.j7h_1 = 'null';
      }
      k20() {
        var tmp0 = this.f7h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_viewedByCustomer$_get_name_$ref_ddufkk(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.r7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      c7g(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.c7g(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g7h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_viewedByCustomer$_get_serializer_$ref_nwsrot(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h7h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_viewedByCustomer$_get_annotations_$ref_ety83b(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_viewedByCustomer', VOID, VOID, [SerializableProperty()]);
    Project_viewedByCustomerClass = $;
  }
  return Project_viewedByCustomerClass;
}
var Project_viewedByCustomer_instance;
function Project_viewedByCustomer_getInstance() {
  if (Project_viewedByCustomer_instance === VOID)
    new (Project_viewedByCustomer())();
  return Project_viewedByCustomer_instance;
}
function Project_approved$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(21);
}
function Project_approved$_get_name_$ref_dgk0bu() {
  return (p0) => p0.k20();
}
function Project_approved$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[21];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_approved$_get_serializer_$ref_6zq6vl() {
  return (p0) => p0.j2j();
}
function Project_approved$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(21);
}
function Project_approved$_get_annotations_$ref_jrwtsb() {
  return (p0) => p0.bz();
}
var Project_approvedClass;
function Project_approved() {
  if (Project_approvedClass === VOID) {
    class $ {
      constructor() {
        Project_approved_instance = this;
        var tmp = this;
        tmp.k7h_1 = lazy(Project_approved$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l7h_1 = lazy(Project_approved$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m7h_1 = lazy(Project_approved$annotations$delegate$lambda);
        this.n7h_1 = null;
        this.o7h_1 = 'null';
      }
      k20() {
        var tmp0 = this.k7h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_approved$_get_name_$ref_dgk0bu(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.s7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      u7g(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.u7g(tmp, (value == null ? true : value instanceof AccessInfo()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.l7h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_approved$_get_serializer_$ref_6zq6vl(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m7h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_approved$_get_annotations_$ref_jrwtsb(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_approved', VOID, VOID, [SerializableProperty()]);
    Project_approvedClass = $;
  }
  return Project_approvedClass;
}
var Project_approved_instance;
function Project_approved_getInstance() {
  if (Project_approved_instance === VOID)
    new (Project_approved())();
  return Project_approved_instance;
}
function Project_terminated$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(22);
}
function Project_terminated$_get_name_$ref_4mu42e() {
  return (p0) => p0.k20();
}
function Project_terminated$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[22];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_terminated$_get_serializer_$ref_zebjr1() {
  return (p0) => p0.j2j();
}
function Project_terminated$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(22);
}
function Project_terminated$_get_annotations_$ref_n25std() {
  return (p0) => p0.bz();
}
var Project_terminatedClass;
function Project_terminated() {
  if (Project_terminatedClass === VOID) {
    class $ {
      constructor() {
        Project_terminated_instance = this;
        var tmp = this;
        tmp.p7h_1 = lazy(Project_terminated$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q7h_1 = lazy(Project_terminated$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r7h_1 = lazy(Project_terminated$annotations$delegate$lambda);
        this.s7h_1 = null;
        this.t7h_1 = 'null';
      }
      k20() {
        var tmp0 = this.p7h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_terminated$_get_name_$ref_4mu42e(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.t7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      c7g(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.c7g(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.q7h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_terminated$_get_serializer_$ref_zebjr1(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r7h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_terminated$_get_annotations_$ref_n25std(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_terminated', VOID, VOID, [SerializableProperty()]);
    Project_terminatedClass = $;
  }
  return Project_terminatedClass;
}
var Project_terminated_instance;
function Project_terminated_getInstance() {
  if (Project_terminated_instance === VOID)
    new (Project_terminated())();
  return Project_terminated_instance;
}
function Project_complete$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(23);
}
function Project_complete$_get_name_$ref_3n7vkk() {
  return (p0) => p0.k20();
}
function Project_complete$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[23];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_complete$_get_serializer_$ref_d8mzql() {
  return (p0) => p0.j2j();
}
function Project_complete$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(23);
}
function Project_complete$_get_annotations_$ref_vukmh5() {
  return (p0) => p0.bz();
}
var Project_completeClass;
function Project_complete() {
  if (Project_completeClass === VOID) {
    class $ {
      constructor() {
        Project_complete_instance = this;
        var tmp = this;
        tmp.u7h_1 = lazy(Project_complete$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v7h_1 = lazy(Project_complete$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w7h_1 = lazy(Project_complete$annotations$delegate$lambda);
        this.x7h_1 = null;
        this.y7h_1 = 'null';
      }
      k20() {
        var tmp0 = this.u7h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_complete$_get_name_$ref_3n7vkk(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.u7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      z7h(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.z7h(tmp, (value == null ? true : value instanceof CompletionRequest()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.v7h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_complete$_get_serializer_$ref_d8mzql(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w7h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_complete$_get_annotations_$ref_vukmh5(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_complete', VOID, VOID, [SerializableProperty()]);
    Project_completeClass = $;
  }
  return Project_completeClass;
}
var Project_complete_instance;
function Project_complete_getInstance() {
  if (Project_complete_instance === VOID)
    new (Project_complete())();
  return Project_complete_instance;
}
function Project_originalPrice$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(26);
}
function Project_originalPrice$_get_name_$ref_p8aptr() {
  return (p0) => p0.k20();
}
function Project_originalPrice$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[26];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_originalPrice$_get_serializer_$ref_wha862() {
  return (p0) => p0.j2j();
}
function Project_originalPrice$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(26);
}
function Project_originalPrice$_get_annotations_$ref_3ngsye() {
  return (p0) => p0.bz();
}
var Project_originalPriceClass;
function Project_originalPrice() {
  if (Project_originalPriceClass === VOID) {
    class $ {
      constructor() {
        Project_originalPrice_instance = this;
        var tmp = this;
        tmp.a7i_1 = lazy(Project_originalPrice$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b7i_1 = lazy(Project_originalPrice$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c7i_1 = lazy(Project_originalPrice$annotations$delegate$lambda);
        this.d7i_1 = _MonetaryValue___init__impl__jsc11x(0n);
        this.e7i_1 = 'MonetaryValue(0L)';
      }
      k20() {
        var tmp0 = this.a7i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_originalPrice$_get_name_$ref_p8aptr(), null);
        return tmp0.f2();
      }
      l7f(receiver) {
        return receiver.x7b_1;
      }
      m2j(receiver) {
        return new (MonetaryValue())(this.l7f(receiver instanceof Project() ? receiver : THROW_CCE()));
      }
      m7f(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.m7f(tmp, value instanceof MonetaryValue() ? value.a5s_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.b7i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_originalPrice$_get_serializer_$ref_wha862(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c7i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_originalPrice$_get_annotations_$ref_3ngsye(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_originalPrice', VOID, VOID, [SerializableProperty()]);
    Project_originalPriceClass = $;
  }
  return Project_originalPriceClass;
}
var Project_originalPrice_instance;
function Project_originalPrice_getInstance() {
  if (Project_originalPrice_instance === VOID)
    new (Project_originalPrice())();
  return Project_originalPrice_instance;
}
function Project_activePrice$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(27);
}
function Project_activePrice$_get_name_$ref_4149oq() {
  return (p0) => p0.k20();
}
function Project_activePrice$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[27];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_activePrice$_get_serializer_$ref_52frkf() {
  return (p0) => p0.j2j();
}
function Project_activePrice$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(27);
}
function Project_activePrice$_get_annotations_$ref_12cfvv() {
  return (p0) => p0.bz();
}
var Project_activePriceClass;
function Project_activePrice() {
  if (Project_activePriceClass === VOID) {
    class $ {
      constructor() {
        Project_activePrice_instance = this;
        var tmp = this;
        tmp.f7i_1 = lazy(Project_activePrice$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g7i_1 = lazy(Project_activePrice$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h7i_1 = lazy(Project_activePrice$annotations$delegate$lambda);
        this.i7i_1 = _MonetaryValue___init__impl__jsc11x(0n);
        this.j7i_1 = 'MonetaryValue(0L)';
      }
      k20() {
        var tmp0 = this.f7i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_activePrice$_get_name_$ref_4149oq(), null);
        return tmp0.f2();
      }
      l7f(receiver) {
        return receiver.y7b_1;
      }
      m2j(receiver) {
        return new (MonetaryValue())(this.l7f(receiver instanceof Project() ? receiver : THROW_CCE()));
      }
      m7f(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.m7f(tmp, value instanceof MonetaryValue() ? value.a5s_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g7i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_activePrice$_get_serializer_$ref_52frkf(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h7i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_activePrice$_get_annotations_$ref_12cfvv(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_activePrice', VOID, VOID, [SerializableProperty()]);
    Project_activePriceClass = $;
  }
  return Project_activePriceClass;
}
var Project_activePrice_instance;
function Project_activePrice_getInstance() {
  if (Project_activePrice_instance === VOID)
    new (Project_activePrice())();
  return Project_activePrice_instance;
}
function Project_projectCredits$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(28);
}
function Project_projectCredits$_get_name_$ref_mgxczw() {
  return (p0) => p0.k20();
}
function Project_projectCredits$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[28];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_projectCredits$_get_serializer_$ref_wwj9cr() {
  return (p0) => p0.j2j();
}
function Project_projectCredits$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(28);
}
function Project_projectCredits$_get_annotations_$ref_tcep4v() {
  return (p0) => p0.bz();
}
var Project_projectCreditsClass;
function Project_projectCredits() {
  if (Project_projectCreditsClass === VOID) {
    class $ {
      constructor() {
        Project_projectCredits_instance = this;
        var tmp = this;
        tmp.k7i_1 = lazy(Project_projectCredits$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l7i_1 = lazy(Project_projectCredits$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m7i_1 = lazy(Project_projectCredits$annotations$delegate$lambda);
        this.n7i_1 = emptyList();
        this.o7i_1 = 'emptyList()';
      }
      k20() {
        var tmp0 = this.k7i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_projectCredits$_get_name_$ref_mgxczw(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.z7b_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      p7i(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.p7i(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.l7i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_projectCredits$_get_serializer_$ref_wwj9cr(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m7i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_projectCredits$_get_annotations_$ref_tcep4v(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_projectCredits', VOID, VOID, [SerializableProperty()]);
    Project_projectCreditsClass = $;
  }
  return Project_projectCreditsClass;
}
var Project_projectCredits_instance;
function Project_projectCredits_getInstance() {
  if (Project_projectCredits_instance === VOID)
    new (Project_projectCredits())();
  return Project_projectCredits_instance;
}
function Project_acceptedChangeAmount$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(29);
}
function Project_acceptedChangeAmount$_get_name_$ref_dorw4i() {
  return (p0) => p0.k20();
}
function Project_acceptedChangeAmount$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[29];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_acceptedChangeAmount$_get_serializer_$ref_fiyu4p() {
  return (p0) => p0.j2j();
}
function Project_acceptedChangeAmount$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(29);
}
function Project_acceptedChangeAmount$_get_annotations_$ref_7wmqb() {
  return (p0) => p0.bz();
}
var Project_acceptedChangeAmountClass;
function Project_acceptedChangeAmount() {
  if (Project_acceptedChangeAmountClass === VOID) {
    class $ {
      constructor() {
        Project_acceptedChangeAmount_instance = this;
        var tmp = this;
        tmp.q7i_1 = lazy(Project_acceptedChangeAmount$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r7i_1 = lazy(Project_acceptedChangeAmount$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s7i_1 = lazy(Project_acceptedChangeAmount$annotations$delegate$lambda);
        this.t7i_1 = _MonetaryValue___init__impl__jsc11x(0n);
        this.u7i_1 = 'MonetaryValue(0L)';
      }
      k20() {
        var tmp0 = this.q7i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_acceptedChangeAmount$_get_name_$ref_dorw4i(), null);
        return tmp0.f2();
      }
      l7f(receiver) {
        return receiver.a7c_1;
      }
      m2j(receiver) {
        return new (MonetaryValue())(this.l7f(receiver instanceof Project() ? receiver : THROW_CCE()));
      }
      m7f(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.m7f(tmp, value instanceof MonetaryValue() ? value.a5s_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.r7i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_acceptedChangeAmount$_get_serializer_$ref_fiyu4p(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s7i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_acceptedChangeAmount$_get_annotations_$ref_7wmqb(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_acceptedChangeAmount', VOID, VOID, [SerializableProperty()]);
    Project_acceptedChangeAmountClass = $;
  }
  return Project_acceptedChangeAmountClass;
}
var Project_acceptedChangeAmount_instance;
function Project_acceptedChangeAmount_getInstance() {
  if (Project_acceptedChangeAmount_instance === VOID)
    new (Project_acceptedChangeAmount())();
  return Project_acceptedChangeAmount_instance;
}
function Project_fundingRequested$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(30);
}
function Project_fundingRequested$_get_name_$ref_kyisdg() {
  return (p0) => p0.k20();
}
function Project_fundingRequested$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[30];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_fundingRequested$_get_serializer_$ref_z67ccr() {
  return (p0) => p0.j2j();
}
function Project_fundingRequested$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(30);
}
function Project_fundingRequested$_get_annotations_$ref_u1s63z() {
  return (p0) => p0.bz();
}
var Project_fundingRequestedClass;
function Project_fundingRequested() {
  if (Project_fundingRequestedClass === VOID) {
    class $ {
      constructor() {
        Project_fundingRequested_instance = this;
        var tmp = this;
        tmp.v7i_1 = lazy(Project_fundingRequested$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w7i_1 = lazy(Project_fundingRequested$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x7i_1 = lazy(Project_fundingRequested$annotations$delegate$lambda);
        this.y7i_1 = _MonetaryValue___init__impl__jsc11x(0n);
        this.z7i_1 = 'MonetaryValue(0L)';
      }
      k20() {
        var tmp0 = this.v7i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_fundingRequested$_get_name_$ref_kyisdg(), null);
        return tmp0.f2();
      }
      l7f(receiver) {
        return receiver.b7c_1;
      }
      m2j(receiver) {
        return new (MonetaryValue())(this.l7f(receiver instanceof Project() ? receiver : THROW_CCE()));
      }
      m7f(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.m7f(tmp, value instanceof MonetaryValue() ? value.a5s_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.w7i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_fundingRequested$_get_serializer_$ref_z67ccr(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x7i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_fundingRequested$_get_annotations_$ref_u1s63z(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_fundingRequested', VOID, VOID, [SerializableProperty()]);
    Project_fundingRequestedClass = $;
  }
  return Project_fundingRequestedClass;
}
var Project_fundingRequested_instance;
function Project_fundingRequested_getInstance() {
  if (Project_fundingRequested_instance === VOID)
    new (Project_fundingRequested())();
  return Project_fundingRequested_instance;
}
function Project_pendingClientDeposits$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(32);
}
function Project_pendingClientDeposits$_get_name_$ref_tvuaqq() {
  return (p0) => p0.k20();
}
function Project_pendingClientDeposits$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[32];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_pendingClientDeposits$_get_serializer_$ref_1oze4b() {
  return (p0) => p0.j2j();
}
function Project_pendingClientDeposits$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(32);
}
function Project_pendingClientDeposits$_get_annotations_$ref_ymbys7() {
  return (p0) => p0.bz();
}
var Project_pendingClientDepositsClass;
function Project_pendingClientDeposits() {
  if (Project_pendingClientDepositsClass === VOID) {
    class $ {
      constructor() {
        Project_pendingClientDeposits_instance = this;
        var tmp = this;
        tmp.a7j_1 = lazy(Project_pendingClientDeposits$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b7j_1 = lazy(Project_pendingClientDeposits$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c7j_1 = lazy(Project_pendingClientDeposits$annotations$delegate$lambda);
        this.d7j_1 = _MonetaryValue___init__impl__jsc11x(0n);
        this.e7j_1 = 'MonetaryValue(0L)';
      }
      k20() {
        var tmp0 = this.a7j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_pendingClientDeposits$_get_name_$ref_tvuaqq(), null);
        return tmp0.f2();
      }
      l7f(receiver) {
        return receiver.d7c_1;
      }
      m2j(receiver) {
        return new (MonetaryValue())(this.l7f(receiver instanceof Project() ? receiver : THROW_CCE()));
      }
      m7f(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.m7f(tmp, value instanceof MonetaryValue() ? value.a5s_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.b7j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_pendingClientDeposits$_get_serializer_$ref_1oze4b(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c7j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_pendingClientDeposits$_get_annotations_$ref_ymbys7(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_pendingClientDeposits', VOID, VOID, [SerializableProperty()]);
    Project_pendingClientDepositsClass = $;
  }
  return Project_pendingClientDepositsClass;
}
var Project_pendingClientDeposits_instance;
function Project_pendingClientDeposits_getInstance() {
  if (Project_pendingClientDeposits_instance === VOID)
    new (Project_pendingClientDeposits())();
  return Project_pendingClientDeposits_instance;
}
function Project_clientReturn$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(34);
}
function Project_clientReturn$_get_name_$ref_7s2r7y() {
  return (p0) => p0.k20();
}
function Project_clientReturn$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[34];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_clientReturn$_get_serializer_$ref_9czk6t() {
  return (p0) => p0.j2j();
}
function Project_clientReturn$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(34);
}
function Project_clientReturn$_get_annotations_$ref_m5v8h3() {
  return (p0) => p0.bz();
}
var Project_clientReturnClass;
function Project_clientReturn() {
  if (Project_clientReturnClass === VOID) {
    class $ {
      constructor() {
        Project_clientReturn_instance = this;
        var tmp = this;
        tmp.f7j_1 = lazy(Project_clientReturn$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g7j_1 = lazy(Project_clientReturn$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h7j_1 = lazy(Project_clientReturn$annotations$delegate$lambda);
        this.i7j_1 = _MonetaryValue___init__impl__jsc11x(0n);
        this.j7j_1 = 'MonetaryValue(0L)';
      }
      k20() {
        var tmp0 = this.f7j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_clientReturn$_get_name_$ref_7s2r7y(), null);
        return tmp0.f2();
      }
      l7f(receiver) {
        return receiver.f7c_1;
      }
      m2j(receiver) {
        return new (MonetaryValue())(this.l7f(receiver instanceof Project() ? receiver : THROW_CCE()));
      }
      m7f(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.m7f(tmp, value instanceof MonetaryValue() ? value.a5s_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g7j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_clientReturn$_get_serializer_$ref_9czk6t(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h7j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_clientReturn$_get_annotations_$ref_m5v8h3(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_clientReturn', VOID, VOID, [SerializableProperty()]);
    Project_clientReturnClass = $;
  }
  return Project_clientReturnClass;
}
var Project_clientReturn_instance;
function Project_clientReturn_getInstance() {
  if (Project_clientReturn_instance === VOID)
    new (Project_clientReturn())();
  return Project_clientReturn_instance;
}
function Project_started$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(35);
}
function Project_started$_get_name_$ref_6av89k() {
  return (p0) => p0.k20();
}
function Project_started$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[35];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_started$_get_serializer_$ref_h10znz() {
  return (p0) => p0.j2j();
}
function Project_started$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(35);
}
function Project_started$_get_annotations_$ref_o9cnn7() {
  return (p0) => p0.bz();
}
var Project_startedClass;
function Project_started() {
  if (Project_startedClass === VOID) {
    class $ {
      constructor() {
        Project_started_instance = this;
        var tmp = this;
        tmp.k7j_1 = lazy(Project_started$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l7j_1 = lazy(Project_started$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m7j_1 = lazy(Project_started$annotations$delegate$lambda);
        this.n7j_1 = null;
        this.o7j_1 = 'null';
      }
      k20() {
        var tmp0 = this.k7j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_started$_get_name_$ref_6av89k(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.g7c_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      c7g(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.c7g(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.l7j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_started$_get_serializer_$ref_h10znz(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m7j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_started$_get_annotations_$ref_o9cnn7(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_started', VOID, VOID, [SerializableProperty()]);
    Project_startedClass = $;
  }
  return Project_startedClass;
}
var Project_started_instance;
function Project_started_getInstance() {
  if (Project_started_instance === VOID)
    new (Project_started())();
  return Project_started_instance;
}
function Project_preSubstantialCompletion$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(36);
}
function Project_preSubstantialCompletion$_get_name_$ref_20ekqi() {
  return (p0) => p0.k20();
}
function Project_preSubstantialCompletion$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[36];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_preSubstantialCompletion$_get_serializer_$ref_oawwdb() {
  return (p0) => p0.j2j();
}
function Project_preSubstantialCompletion$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(36);
}
function Project_preSubstantialCompletion$_get_annotations_$ref_qzi96t() {
  return (p0) => p0.bz();
}
var Project_preSubstantialCompletionClass;
function Project_preSubstantialCompletion() {
  if (Project_preSubstantialCompletionClass === VOID) {
    class $ {
      constructor() {
        Project_preSubstantialCompletion_instance = this;
        var tmp = this;
        tmp.p7j_1 = lazy(Project_preSubstantialCompletion$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q7j_1 = lazy(Project_preSubstantialCompletion$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r7j_1 = lazy(Project_preSubstantialCompletion$annotations$delegate$lambda);
        this.s7j_1 = null;
        this.t7j_1 = 'null';
      }
      k20() {
        var tmp0 = this.p7j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_preSubstantialCompletion$_get_name_$ref_20ekqi(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.h7c_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      c7g(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.c7g(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.q7j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_preSubstantialCompletion$_get_serializer_$ref_oawwdb(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r7j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_preSubstantialCompletion$_get_annotations_$ref_qzi96t(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_preSubstantialCompletion', VOID, VOID, [SerializableProperty()]);
    Project_preSubstantialCompletionClass = $;
  }
  return Project_preSubstantialCompletionClass;
}
var Project_preSubstantialCompletion_instance;
function Project_preSubstantialCompletion_getInstance() {
  if (Project_preSubstantialCompletion_instance === VOID)
    new (Project_preSubstantialCompletion())();
  return Project_preSubstantialCompletion_instance;
}
function Project_substantialCompletion$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(37);
}
function Project_substantialCompletion$_get_name_$ref_wxd69() {
  return (p0) => p0.k20();
}
function Project_substantialCompletion$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[37];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_substantialCompletion$_get_serializer_$ref_qhbp7c() {
  return (p0) => p0.j2j();
}
function Project_substantialCompletion$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(37);
}
function Project_substantialCompletion$_get_annotations_$ref_fckvvg() {
  return (p0) => p0.bz();
}
var Project_substantialCompletionClass;
function Project_substantialCompletion() {
  if (Project_substantialCompletionClass === VOID) {
    class $ {
      constructor() {
        Project_substantialCompletion_instance = this;
        var tmp = this;
        tmp.u7j_1 = lazy(Project_substantialCompletion$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v7j_1 = lazy(Project_substantialCompletion$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w7j_1 = lazy(Project_substantialCompletion$annotations$delegate$lambda);
        this.x7j_1 = null;
        this.y7j_1 = 'null';
      }
      k20() {
        var tmp0 = this.u7j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_substantialCompletion$_get_name_$ref_wxd69(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.i7c_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      c7g(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.c7g(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.v7j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_substantialCompletion$_get_serializer_$ref_qhbp7c(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w7j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_substantialCompletion$_get_annotations_$ref_fckvvg(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_substantialCompletion', VOID, VOID, [SerializableProperty()]);
    Project_substantialCompletionClass = $;
  }
  return Project_substantialCompletionClass;
}
var Project_substantialCompletion_instance;
function Project_substantialCompletion_getInstance() {
  if (Project_substantialCompletion_instance === VOID)
    new (Project_substantialCompletion())();
  return Project_substantialCompletion_instance;
}
function Project_locked$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(38);
}
function Project_locked$_get_name_$ref_vjzisd() {
  return (p0) => p0.k20();
}
function Project_locked$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[38];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_locked$_get_serializer_$ref_gj7b0() {
  return (p0) => p0.j2j();
}
function Project_locked$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(38);
}
function Project_locked$_get_annotations_$ref_1v5s1k() {
  return (p0) => p0.bz();
}
var Project_lockedClass;
function Project_locked() {
  if (Project_lockedClass === VOID) {
    class $ {
      constructor() {
        Project_locked_instance = this;
        var tmp = this;
        tmp.z7j_1 = lazy(Project_locked$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a7k_1 = lazy(Project_locked$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b7k_1 = lazy(Project_locked$annotations$delegate$lambda);
        this.c7k_1 = null;
        this.d7k_1 = 'null';
      }
      k20() {
        var tmp0 = this.z7j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_locked$_get_name_$ref_vjzisd(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.j7c_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      e7k(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.e7k(tmp, (value == null ? true : value instanceof LockInfo()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.a7k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_locked$_get_serializer_$ref_gj7b0(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b7k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_locked$_get_annotations_$ref_1v5s1k(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_locked', VOID, VOID, [SerializableProperty()]);
    Project_lockedClass = $;
  }
  return Project_lockedClass;
}
var Project_locked_instance;
function Project_locked_getInstance() {
  if (Project_locked_instance === VOID)
    new (Project_locked())();
  return Project_locked_instance;
}
function Project_lastModifiedBy$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(39);
}
function Project_lastModifiedBy$_get_name_$ref_5gjukp() {
  return (p0) => p0.k20();
}
function Project_lastModifiedBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[39];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Project_lastModifiedBy$_get_serializer_$ref_n6wa8() {
  return (p0) => p0.j2j();
}
function Project_lastModifiedBy$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(39);
}
function Project_lastModifiedBy$_get_annotations_$ref_yyh6no() {
  return (p0) => p0.bz();
}
var Project_lastModifiedByClass;
function Project_lastModifiedBy() {
  if (Project_lastModifiedByClass === VOID) {
    class $ {
      constructor() {
        Project_lastModifiedBy_instance = this;
        var tmp = this;
        tmp.f7k_1 = lazy(Project_lastModifiedBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g7k_1 = lazy(Project_lastModifiedBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h7k_1 = lazy(Project_lastModifiedBy$annotations$delegate$lambda);
        this.i7k_1 = null;
        this.j7k_1 = 'null';
      }
      k20() {
        var tmp0 = this.f7k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Project_lastModifiedBy$_get_name_$ref_5gjukp(), null);
        return tmp0.f2();
      }
      w7a(receiver) {
        return receiver.k7c_1;
      }
      m2j(receiver) {
        return this.w7a(receiver instanceof Project() ? receiver : THROW_CCE());
      }
      l7c(receiver, value) {
        return receiver.m7c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Project() ? receiver : THROW_CCE();
        return this.l7c(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g7k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Project_lastModifiedBy$_get_serializer_$ref_n6wa8(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h7k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Project_lastModifiedBy$_get_annotations_$ref_yyh6no(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Project_lastModifiedBy', VOID, VOID, [SerializableProperty()]);
    Project_lastModifiedByClass = $;
  }
  return Project_lastModifiedByClass;
}
var Project_lastModifiedBy_instance;
function Project_lastModifiedBy_getInstance() {
  if (Project_lastModifiedBy_instance === VOID)
    new (Project_lastModifiedBy())();
  return Project_lastModifiedBy_instance;
}
//region block: exports
export {
  get_address as get_address2ugvw4aqvl14f,
  get_client as get_client1ubw0usktkrr9,
  get_clientDeposits as get_clientDeposits3iceuvgspasbp,
  get_contractor as get_contractor2weo1umt9id6t,
  get_contractorPayments as get_contractorPayments1uble8nvvhe26,
  get_contractorShortId as get_contractorShortIda0pelhgoksfc,
  get_created as get_created373kmke1rp67y,
  get_customer as get_customer1w9vmrtgthst,
  get_description as get_description1alejogxbwk1g,
  get_isArchived as get_isArchived1blzbvus67h1w,
  get_jobNumber as get_jobNumber1ji61at3fhtkt,
  get_location as get_location3tupc403seoj2,
  get_name as get_nameo9a32lyl7xbh,
  prepareProjectFields as prepareProjectFields3fakc8cuzeqc3,
  get_retention as get_retention1b8iabda9w129,
  get_shortId as get_shortIdgzet16nwxhwb,
  get_state as get_state23zbf4that7g,
  Project_address_getInstance as Project_address_getInstance1sy7wzxhn0yu9,
  Project_client_getInstance as Project_client_getInstance2fyj3drng1pzf,
  Project_description_getInstance as Project_description_getInstance1d13ic72v68j0,
  Project_files_getInstance as Project_files_getInstance31nstm5s64zap,
  Project_jobNumber_getInstance as Project_jobNumber_getInstanceccw665heymuq,
  Project_location_getInstance as Project_location_getInstance3a2xpkrgh6b4p,
  Project_name_getInstance as Project_name_getInstance3dymwrzmzfu1r,
  Project_retention_getInstance as Project_retention_getInstance3f845iagwlyjt,
};
//endregion

//# sourceMappingURL=ProjectFields.mjs.map
